import { DocumentSharingStatusEnum, DriveEventActionEnum, DriveEventSubActionEnum } from '@workalizer/shared/enums';
export var DRIVE_SHARING_EVENT_ACTIONS = [
    DriveEventActionEnum.DOCUMENT_SHARE,
    DriveEventActionEnum.DOCUMENT_CHANGE_ACCESS,
    DriveEventActionEnum.DOCUMENT_PUBLISH
];
var SHARING_EVENT_ACTION_SET = new Set(DRIVE_SHARING_EVENT_ACTIONS);
var PUBLIC_LINK_SUB_ACTIONS = new Set([
    DriveEventSubActionEnum.DOCUMENT_PEOPLE_WITH_LINK,
    DriveEventSubActionEnum.DOCUMENT_PUBLIC_IN_THE_DOMAIN,
    DriveEventSubActionEnum.DOCUMENT_PEOPLE_WITHIN_DOMAIN_WITH_LINK
]);
export var isDriveSharingEventAction = function (action) {
    return SHARING_EVENT_ACTION_SET.has(action);
};
export var getDriveSharingStatus = function (action, subAction) {
    if (action === DriveEventActionEnum.DOCUMENT_PUBLISH) {
        return DocumentSharingStatusEnum.PUBLIC_LINK;
    }
    if (!isDriveSharingEventAction(action) || !subAction) {
        return null;
    }
    if (subAction === DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY) {
        return DocumentSharingStatusEnum.INTERNAL;
    }
    if (subAction === DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY) {
        return DocumentSharingStatusEnum.EXTERNAL;
    }
    if (PUBLIC_LINK_SUB_ACTIONS.has(subAction)) {
        return DocumentSharingStatusEnum.PUBLIC_LINK;
    }
    return null;
};
